import { AuthLogicActions } from './actions';

export const updateUserData = AuthLogicActions.updateUser;
